module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /app/node_modules/symbol-observable/index.js
// module id = 573
// module chunks = 1